/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Paypal_Webhook_IdInputs */

const en_admin_settings_fields_paypal_webhook_id = /** @type {(inputs: Admin_Settings_Fields_Paypal_Webhook_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhook ID`)
};

/**
* | output |
* | --- |
* | "Webhook ID" |
*
* @param {Admin_Settings_Fields_Paypal_Webhook_IdInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_paypal_webhook_id = /** @type {((inputs?: Admin_Settings_Fields_Paypal_Webhook_IdInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Paypal_Webhook_IdInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_paypal_webhook_id(inputs)
});
export { admin_settings_fields_paypal_webhook_id as "admin.settings.fields.paypal_webhook_id" }